import PropTypes from 'prop-types';
import React from 'react';
import {
  withStyles,
  Tooltip,
  Typography,
  Icon,
} from '@material-ui/core';
import styles from './styles';
import {
  formatDateString,
  getRelativeTime,
} from '../../../utils/dateHelper';
import { getCommentStringFromMentionString } from '../../../utils/mentions-helper';

import StatusBadge from '../StatusBadge';
import User from '../User';

export const getColorForItem = (itemList, elementId) => {
  const item = itemList.filter((i) => i.id === elementId)[0];
  return item === undefined
    ? ''
    : item.iconColor;
};

export const EventStatusComponent = ({
  eventStatus,
  color,
  icon,
  hideComment,
  hideDate,
  classes,
  showDuration,
  mini,
}) => {
  if (mini) {
    return (
      <StatusBadge
        icon={icon}
        iconColor={color}
        size={40}
        margin
        mini
      />
    );
  }
  return (
    <div>
      <div>
        <div className={classes.statusContainer}>
          <div className={classes.statusIcon}>
            <StatusBadge
              icon={icon}
              iconColor={color}
              size={40}
              margin
            />
          </div>
          <div
            className={classes.status}
            name="status-name"
          >
            <div className={classes.statusWrapper}>
              {eventStatus.status.name}
            </div>
            <div className={classes.timeContainer}>
              {
                !hideDate
                  && <span className={classes.statusDate}>{formatDateString(eventStatus.createdDate)}</span>
              }
              {
                !!showDuration
                  && (
                    <span className={classes.duration}>
                      {
                        (
                          !eventStatus.nextEventStatus
                            || !eventStatus.nextEventStatus.createdDate
                        )
                          ? <Icon fontSize="inherit" className={classes.statusDurationIcon}>alarm</Icon>
                          : <Icon fontSize="inherit" className={classes.statusDurationIcon}>alarm_on</Icon>
                      }
                      &nbsp;{getRelativeTime(eventStatus.createdDate, (eventStatus.nextEventStatus || {}).createdDate)}
                    </span>
                  )
              }
            </div>
          </div>
        </div>
      </div>
      {/* TODO create popover to replace tooltip
            component with more details and a white/clean background  */}

      {
        !hideComment
          && eventStatus.statusComment
          && eventStatus.statusComment.length > 0
          && (
            <Tooltip title={`${eventStatus.createdByEmail}: ${getCommentStringFromMentionString(eventStatus.statusComment)}`}>
              <span className={classes.eventStatusComment}>
                <User
                  mini
                  user={{
                    email: eventStatus.createdByEmail,
                    userFullName: eventStatus.createdBy,
                  }}
                  className={classes.commentIcon}
                />
                <Typography className={classes.commentText} noWrap>
                  {
                    getCommentStringFromMentionString(eventStatus.statusComment)
                  }
                </Typography>
              </span>
            </Tooltip>
          )
      }
    </div>
  );
};

EventStatusComponent.propTypes = {
  eventStatus: PropTypes.object,
  classes: PropTypes.object,
  color: PropTypes.string,
  icon: PropTypes.string,
  hideComment: PropTypes.bool,
  hideDate: PropTypes.bool,
  showDuration: PropTypes.bool,
  mini: PropTypes.bool,
};

EventStatusComponent.defaultProps = {
  eventStatus: { nextEventStatus: {} },
  classes: {},
  color: '',
  icon: '',
  hideComment: false,
  hideDate: false,
  showDuration: true,
  mini: false,
};

export default withStyles(styles)(EventStatusComponent);
